<template>
		<card>
				<template slot="header">
						<h5 v-if="$slots.title || title" class="card-title">
								<slot name="title">
										{{title}}
								</slot>
						</h5>
				</template>
				<div class="container-fluid">
						<div class="row  card-group">
								<div class="text-center col-lg-3 col-md-6 col-sm-6">
										<div class="card-block">
												<h4 id="co-tablecell-title1" class="kpi-title">{{ previousTitle }}</h4>
												<div id="co-tablecell-value1" class="kpi-content">{{ previousCO2 }} Kg</div>
										</div>
								</div>
								<div class="text-center col-lg-3 col-md-6 col-sm-6">
										<div class="card-block">
												<h4 id="co-tablecell-title2" class="kpi-title">{{ sofarTitle }}</h4>
												<div id="co-tablecell-value2" class="kpi-content">{{ sofarCO2 }} Kg</div>
										</div>
								</div>
								<div class="text-center col-lg-3 col-md-6 col-sm-6">
										<div class="card-block">
												<h4 id="co-tablecell-title3" class="kpi-title">{{ predictTitle }}</h4>
												<div id="co-tablecell-value3" class="kpi-content">{{ predictedCO2 }} Kg</div>
										</div>
								</div>
								<div class="text-center col-lg-3 col-md-6 col-sm-6">
										<div class="card-block">
												<h4 id="co-tablecell-title4" class="kpi-title">Change in emissions</h4>
												<div id="co-tablecell-value4" class="kpi-content" v-if="changedPercent > 0">{{ changedPercent }} % ▲ </div>
												<div id="co-tablecell-value5" class="kpi-content" v-else>{{ Math.abs(changedPercent) }} % ▼</div>
										</div>
								</div>
						</div>
						<div class="row pl-5 pr-5 pt-4 mt-3">
								<div class="col-xl-4 offset-xl-4 col-lg-6 mb-3 text-center">
										<label class="label-info text-white">Usage By: &nbsp;</label>
										<select id="appliance-select"  @change="selectField($event)" v-model="fieldName">
												<option v-for="usage in usages" :value="usage.value">{{ usage.label }}</option>
										</select>
								</div>
						</div>
						<div class="row">
								<div class="col-xl-12">
										<vue-loaders-line-spin-fade-loader class="loading" color="white" scale="1.4"  v-if="isLoading"/>
										<v-chart class="chart" :option="option" v-else/>
								</div>
						</div>
				</div>
		</card>
</template>
<script>

import Card from "./Card.vue";
import { mapActions, mapGetters } from "vuex";
import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { BarChart } from "echarts/charts";
import {
		TitleComponent,
		TooltipComponent,
		LegendComponent,
		GridComponent,
		MarkLineComponent,
		MarkPointComponent,
		MarkAreaComponent
} from "echarts/components";
import VChart  from "vue-echarts";
import QuerySetting from '@/mixins/querySetting';
import OctoberData from '@/mixins/octoberData';

use([
		CanvasRenderer,
		BarChart,
		TitleComponent,
		TooltipComponent,
		LegendComponent,
		GridComponent,
		MarkLineComponent,
		MarkPointComponent,
		MarkAreaComponent
]);


export default {
		name: "real-power-card",
		mixins: [QuerySetting, OctoberData],
		props: {
				title: {
						type: String,
						default: ""
				}
		},
		components: {
				Card,
				VChart,
		},
		computed: {
				...mapGetters({
						periodTime: 'settime/getPeriodTime',
						currentDayPower         : 'influx/getCurrentDayPower',
						currentNightPower       : 'influx/getCurrentNightPower',
						prevDayPower                : 'influx/getPrevDayPower',
						prevNightPower          : 'influx/getPrevNightPower',
						predictDayPower         : 'influx/getPredictDayPower',
						predictNightPower       : 'influx/getPredictNightPower',
						user: 'auth/getUser',
						defaultSiteId: 'auth/getDefaultSiteId',
						defaultSiteName: 'auth/defaultSiteName'
				})
		},
		data() {
				return {
						isLoading: false,
						fieldName: 'overall',
						previousTitle: '',
						sofarTitle: '',
						predictTitle: '',
						previousCO2: 0,
						sofarCO2: 0,
						predictedCO2: 0,
						changedPercent: 0,
						monthNames: ["January", "February", "March", "April", "May", "June",
								"July", "August", "September", "October", "November", "December"
						],
						shortMonthNames: [
								'Jan',
								'Feb',
								'Mar',
								'Apr',
								'May',
								'June',
								'July',
								'Aug',
								'Sept',
								'Nov',
								'Dec'
						],
						usages: [],
						markLine: {
								lineStyle: {
										type:'solid',
										color: 'rgb(239, 80, 82)',
								},
								symbol: ['none', 'none'],
								label: {
										show: true,
										formatter: 'Threshold',
										color: 'rgb(239, 80, 82)',
										fontSize: 14
								},
								data: [{type: 'max', name: 'Threshold'}],
						},
						option: {
								tooltip: {
										position: 'top',
										axisPointer: {
												type: 'shadow'
										},
										backgroundColor: "#484E69",
										borderColor: "#484E69",
										textStyle: {
												color: 'white'
										}
								},
								color: ['#58E2C2', '#F7E53B', '#F7E53B'],
								xAxis: {
										type: 'time',
										splitLine: {
												show: true,
												lineStyle: {
														color: 'rgba(255, 255, 255, 0.3)',
														type: 'solid',
														width: 1
												}
										},
										axisLine: {
												lineStyle: {
														type: 'solid',
														width: 2,
														color: 'rgba(255, 255, 255, 0.6)',
												}
										},
										axisTick: {
												show: false
										}
								},
								yAxis: {
										type:'value',
										axisLine: {
												show: true,
												lineStyle: {
														width: 2,
														type: 'solid',
														color: 'rgba(255, 255, 255, 0.6)',
												}
										},
										splitLine: {
												show: true,
												lineStyle: {
														color: 'rgba(255, 255, 255, 0.3)',
														type: 'dashed',
														width: 1
												}
										},
										axisLabel: {
												formatter: '{value} Kg'
										}
								},
								grid: {
										width: '80%',
										height: '60%',
										left: '10%'
								},
								legend: {
										show: true,
										itemWidth: 12,
										itemHeight: 12,
										itemStyle: {
												borderCap: 'square',
												decal: {
														symbol: 'diamond'
												}
										},
										selectedMode: false,
										itemGap: 30,
										textStyle: {
												color: 'white',
												fontSize: 14,
												fontWeight: 100
										},
										bottom: '12%',
										icon: 'rect',
										data: []
								},
								series: [
										{
												type: 'line',
												symbolSize: 0,
												lineStyle: {
														color: '#58E2C2',
														width: 2,
														type: 'solid'
												},
												data: []
										},
										{
												type: 'line',
												symbolSize: 0,
												lineStyle: {
														color: '#58E2C2',
														width: 2,
														type: 'dashed'
												},
												data: []
										},
										{
												type: 'line',
												symbolSize: 0,
												lineStyle: {
														color: '#F7E53B',
														width: 2,
														type: 'solid'
												},
												data: [],
										}
								]
						},
				}
		},
		watch: {
				async periodTime(newValue) {
						this.changeTitle(newValue);
						this.getCarbonData();
				},
				async defaultSiteId(newValue) {
						this.getCarbonData();
				}
		},
		created() {
			let site = this.defaultSiteName !== '' ? this.defaultSiteName : this.user.site;
			if (site === 'Brook Green') {
					this.usages = [
							{ value: "kitchen", label: "Kitchen" },
							{ value: "mbport", label: "MB Port" },
							{ value: "electrak", label: "Electrak" },
							{ value: "ac", label: "A/C Roof Comms Room" },
							{ value: "light", label: "Lights" },
							{ value: "overall", label: "Overall" },
					];
			} else if (site === 'Somewhere Else 2') {
				this.usages = [
					{ value: "overall"                                  , label: "Overall" },
					{ value: "kitchen_db2_p1"                           , label: "Kitchen DB2 P1" },
					{ value: "kitchen_db2_p2"                           , label: "Kitchen DB2 P2" },
					{ value: "kitchen_db2_p3"                           , label: "Kitchen DB2 P3" },
					{ value: "knowatt_p1"                               , label: "Knowatt P1" },
					{ value: "knowatt_p2"                               , label: "Knowatt P2" },
					{ value: "knowatt_p3"                               , label: "Knowatt P3" },
					{ value: "bar_fridge"                               , label: "Bar Fridge" },
					{ value: "cellar_chiller"                           , label: "Cellar Chiller" },
					{ value: "bar_sockets"                              , label: "Bar Sockets" },
					{ value: "leds"                                     , label: "LEDs" },
					{ value: "bar_lights"                               , label: "Bar Lights" },
					{ value: "cellar_sockets"                           , label: "Cellar Sockets" },
					{ value: "bar_sockets_front"                        , label: "Bar Sockets (front)" },
					{ value: "bar_sockets_rear"                         , label: "Bar Sockets (Rear)" },
					{ value: "floor_driers"                             , label: "1st Floor Ladies Driers" },
					{ value: "floor_ladies"                             , label: "1st Floor Ladies Drier" },
					{ value: "floor_gents"                              , label: "1st Floor Gents Drier" },
					{ value: "floor_disabled_drier"                     , label: "Gnd Floor Disabled Drier" },
					{ value: "floor_landing_sockets"                    , label: "1st Floor landing sockets" },
					{ value: "intruder_alarm"                           , label: "Intruder Alarm" },
					{ value: "boiler_cctv"                              , label: "Boiler / CCTV" },
					{ value: "fire_alarm"                               , label: "Fire Alarm" },
					{ value: "stairs_landing_lights"                    , label: "Stairs/Landing/WC Lights" },
					{ value: "front_outside_lights"                     , label: "Front Outside Lights" },
					{ value: "cellar_lobby_lights"                      , label: "Cellar/Lobby Lights" },
					{ value: "fan_oven"                                 , label: "Fan Oven (Kit)" },
					{ value: "kitchen_lights"                           , label: "Kitchen Lights" },
					{ value: "hot_table"                                , label: "Hot Table (Kit)" },
					{ value: "fan_speed_control"                        , label: "X-Fan Speed Control" },
					{ value: "pot_wash_sockets"                         , label: "Pot Wash Sockets" },
					{ value: "dishwasher"                               , label: "Dishwasher (Kitchen)" },
					{ value: "nothing"                                  , label: "????" },
					{ value: "kitchen_sockets"                          , label: "Kitchen Sockets"},
					{ value: "water_heater"                             , label: "Water Heater" },
					{ value: "coffee_machine"                           , label: "Coffee Machine" },
					{ value: "amps"                                     , label: "Amps" }
				];
			} else {
				this.user.devices.forEach(device => {
					if (
						device.device_type !== 'Frequency' &&
						device.device_type !== 'Voltage' &&
						device.device_show === '1'
					) {
						this.usages.push(
							{value: device.device_name, label: device.device_name}
						)
					}
				});
			}
		},
		async mounted() {
				this.changeTitle(this.periodTime);
				this.getCarbonData();
		},
		methods: {
				...mapActions({
						getDisplayData: 'influx/getDisplayData'
				}),
				changeTitle(value) {
						let month;
						switch(value) {
								case 'today':
										let date = new Date();
										date.setDate(date.getDate() - 1);
										month = date.getMonth();
										let monthname = this.monthNames[month];
										let _date = date.getDate();
										this.previousTitle = `${monthname} ${_date}`;
										this.sofarTitle = 'So far today';
										this.predictTitle = 'predicted today';
										break;
								case 'month':
										let today = new Date();
										month = today.getMonth();
										this.previousTitle = this.monthNames[month -1];
										this.sofarTitle = 'So far this month';
										this.predictTitle = 'predicted this month';
										break;
								case 'year':
										let _today = new Date();
										let year = _today.getFullYear() - 1;
										this.previousTitle = year;
										this.sofarTitle = 'So far this year';
										this.predictTitle = 'predicted this year';
										break;
						}
				},
				processMonthData(data) {
						let _data = [];
						let today = new Date();
						let lastDay = new Date(today.getFullYear(), today.getMonth()+1, 0);
						let lastDate = lastDay.getDate();
						let firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
						for (let i = 0; i < lastDate; i++) {
								firstDay.setDate(firstDay.getDate() + 1);
								let timeString = firstDay.toISOString().slice(0, 10);
								let value = 0;
								if (!!data[i]) {
										value = data[i][1];
								}

								let item = [
										firstDay.toISOString().slice(0, 10),
										value
								];
								_data.push(item)
						}

						return _data;
				},
				async getCarbonData() {
						this.isLoading = true;
						let currentDayPower = [],
										currentNightPower = [],
										prevDayPower = [],
										prevNightPower = [],
										predictDayPower = [],
										predictNightPower = [];
						if (this.fieldName == 'overall') {
								await this.getDisplayData('overall');
								currentDayPower = this.currentDayPower;
								currentNightPower = this.currentNightPower;
								prevDayPower = this.prevDayPower;
								prevNightPower = this.prevNightPower;
								predictDayPower = this.predictDayPower;
								predictNightPower = this.predictNightPower;
						} else {
								let powerData = await this.getDisplayData(this.fieldName);
								currentDayPower = powerData[0];
								currentNightPower = powerData[1];
								prevDayPower = powerData[2];
								prevNightPower =  powerData[3];
								predictDayPower =  powerData[6];
								predictNightPower = powerData[7];
						}

						let currentPower = [], prevPower = [], predictPower =[];
						let sofarTotal = 0, previousTotal = 0, predictedTotal = 0;

						if (this.periodTime == 'today') {
								currentPower = currentNightPower.concat(currentDayPower);
								prevPower = prevNightPower.concat(prevDayPower);
								predictPower = predictNightPower.concat(predictDayPower);
								prevPower.forEach((item, index) => {
										let time = new Date(item[0]);
										time.setDate(time.getDate() + 1);
										item[0] = time.toISOString();
								});

								} else {
								currentDayPower.forEach((item, index) => {
										currentPower.push([
												item[0],
												currentNightPower[index]? item[1] + currentNightPower[index][1] : item[1]
										]);
								});

								if (prevDayPower.length > 0 && prevNightPower.length > 0) {
										prevDayPower.forEach((item, index) => {
												let time = new Date(item[0]);
												time.setMonth(time.getMonth() + 1);

												prevPower.push([
														time.toISOString(),
														!!prevNightPower[index]?item[1] + prevNightPower[index][1]:item[1]
												]);
										});
								}

								predictDayPower.forEach((item, index) => {
									let value = !!predictNightPower[index]? item[1] + predictNightPower[index][1] : item[1];
										predictPower.push([
												item[0],
												value
										]);
								});
						}
						let _prevdata = [];
						let _predictdata = [];

						let connectItem = [currentPower[currentPower.length - 1]];
						let predictData = currentPower.concat(connectItem.concat(predictPower));

						if (this.periodTime === 'month') {
								_prevdata = this.processMonthData(prevPower);
								_predictdata = this.processMonthData(predictData);
						}

						currentPower.forEach(item => sofarTotal += item[1] * 0.23314);
						if (this.fieldName == 'overall') {
								this.sofarCO2 = Math.round((sofarTotal + Number.EPSILON) * 100) / 100;
						}
						currentPower.splice(-1);
						this.option.series[0].data = currentPower;

						prevPower.forEach(item => previousTotal += item[1] * 0.23314);
						if (this.fieldName == 'overall') {
								this.previousCO2 = Math.round((previousTotal + Number.EPSILON) * 100) / 100;
						}

						this.option.series[2].data = _prevdata;
						predictPower.forEach(item => predictedTotal += item[1] * 0.23314);

						if (this.fieldName == 'overall') {
								this.predictedCO2 = Math.round((predictedTotal + sofarTotal + Number.EPSILON) * 100) / 100;
						}

						
						this.option.series[1].data = _predictdata;
						this.changedPercent = this.previousCO2 !== 0 ?
																												Math.round(((this.predictedCO2 - this.previousCO2) / this.previousCO2 * 100 + Number.EPSILON) * 100) / 100 : 0;
						this.checkMaxValue(currentPower, predictPower);
						this.checkSeriesName();
				},
				checkSeriesName() {
						let today = new Date();
						let currentString = '';
						let previousString = '';
						let month = 0;

						switch(this.periodTime) {
								case 'today':
										month = today.getMonth();
										let date = today.getDate();
										currentString = `${this.shortMonthNames[month]} ${date}`;

										today.setDate(today.getDate() - 1);
										let _date = today.getDate();
										previousString = `${this.shortMonthNames[month]} ${_date}`;
										this.option.xAxis.splitNumber = 23;
										break;
								case 'month':
										month = today.getMonth();
										this.option.xAxis.splitNumber = 30;
										currentString = this.monthNames[month];

										if (month - 1 < 0) {
												previousString = 'Dec'
										} else {
												previousString = this.monthNames[month - 1];
										}
										break;
								case 'year':
										let year  = today.getFullYear();
										this.option.xAxis.splitNumber = 11;
										currentString = this.monthNames[year];
										previousString = this.monthNames[year - 1];
										break;
						}

						this.option.series[0].name = currentString;
						this.option.series[2].name = previousString;
						this.option.legend.data = [previousString, currentString];
				},
				checkMaxValue(current, predict) {
						let currentMax = Math.max.apply(Math, current.map((o) => { return o[1]; }));
						let predictMax = Math.max.apply(Math, predict.map((o) => { return o[1]; }));
						if (currentMax <= predictMax) {
								if (this.option.series[0].hasOwnProperty('markLine')) {
										delete this.option.series[0].markLine;
								}
								this.option.series[1].markLine = this.markLine;
						} else {
								if (this.option.series[1].hasOwnProperty('markLine')) {
										delete this.option.series[1].markLine;
								}
								this.option.series[0].markLine = this.markLine;
						}
						this.isLoading = false;
				},
				async selectField(event) {
						this.fieldName = event.target.value;
						await this.getCarbonData();
				},
		},
};
</script>
<style lang="scss" scoped>

.chart {
		width: 100%;
		height: 500px;
}

#a2, #a1 {
		color: rgb(253, 253, 253);
		opacity: 0.5;
		text-transform: uppercase;
		cursor: pointer;
}

#a1:before, #a2:before {
		transition: border-bottom 0.3s ease;
}

#appliance-select, #period-select {
		width: 160px;
		height: 30px;
		background-color: #1e365d;
		color: #FFFFFF;
		opacity: 0.9;
		border-color: #fdfdfd;
		border-radius: 4px;
}

.period-text {
		width: 160px;
		height: 30px;
		background-color: #1e365d;
		color: #FFFFFF;
		opacity: 0.9;
		border-radius: 4px;
		border: 1px solid #fdfdfd;
		margin-bottom: 30px;
}

.filter-action {
		width: 160px;
		height: 30px;
		border: 1px solid #fdfdfd;
		background-color: #1e365d;
		color: white;
		border-radius: 4px;
		z-index: 8;
		&:hover {
				background-color: #1f5881;
		}
}

.loading {
		top: 30% !important;
		left: 47% !important;

		padding: 50px;
}

.kpi-title {
		font-size: 16px !important;
		text-transform: uppercase;
		color: #fdfdfd;
		opacity: .8;
		font-family: 'Nunito Sans Light';
		font-weight: 100;
}

.kpi-content, .t-head {
		font-size: 32px;
		color: #fdfdfd;
		font-family: 'Nunito Sans Semi-bold';
}

.t-head {
		text-align: center;
		margin-bottom: 5px;
		padding-bottom: 5px;
		font-size: 32px;
		color: #fdfdfd;
		font-family: 'Nunito Sans Semi-bold';
}
.t-title {
		font-size: 16px;
		font-family: 'Nunito Sans Light';
		text-align: left;
		margin-right: 0;
		margin-top: 0;
		margin-bottom: 0;
		color: hsla(0,0%,99%,.7);
		width: 100%;
		padding: 0 15px;

		.t-content {
				font-size: 16px;
				color: #fdfdfd;
				font-family: 'Nunito Sans Regular' !important;
				float: right;
				margin-left: -10px;
				padding-left: 0;
		}
}

.v-title {
		font-size: 16px;
		font-family: 'Nunito Sans Light';
		text-align: left;
		margin-right: 0;
		margin-top: 0;
		margin-bottom: 0;
		color: white;
		width: 100%;

		.v-content {
				font-size: 16px;
				color: #fdfdfd;
				font-family: 'Nunito Sans Regular' !important;
				float: right;
				margin-left: -10px;
				padding-left: 0;
		}
}

#co-tablecell-value4 {
		color: #E8506B;
}

#co-tablecell-value5 {
		color: #B4F9A1;
}
</style>
